import React from "react";
import { Sparkles, TrendingUp } from "lucide-react";

/**
 * Smart, data-driven boost recommendation badge.
 * Renders nothing unless explicitly enabled + recommended.
 *
 * Feature flag: REACT_APP_FEATURE_BOOST_RECO === "false" disables the whole feature.
 */
const FEATURE_ENABLED = String(process.env.REACT_APP_FEATURE_BOOST_RECO || "true").toLowerCase() !== "false";

const REASON_TEXTS = {
  low_views: "Dieses Inserat performt unterdurchschnittlich",
  low_ctr: "Geringe Anfragen-Quote",
};

export default function SmartBoostBadge({ recommended, reasons = [], upliftFactor, onBoost, disabled, testId }) {
  if (!FEATURE_ENABLED) return null;
  if (!recommended) return null;
  const reason = reasons[0] ? REASON_TEXTS[reasons[0]] || "" : "";
  // Only mention uplift if backend computed a meaningful number (≥1.5×)
  const hint = upliftFactor && upliftFactor >= 1.5
    ? `Inserate mit Boost erhalten ⌀ ${upliftFactor}× mehr Views`
    : "Mehr Sichtbarkeit · top der Suchergebnisse";

  return (
    <button
      type="button"
      onClick={onBoost}
      disabled={disabled}
      data-testid={testId || "smart-boost-badge"}
      className="group mt-2 flex w-full items-start gap-2 rounded-md border border-amber-500/30 bg-gradient-to-r from-amber-500/[0.07] to-red-500/[0.05] px-3 py-2 text-left transition-colors hover:border-amber-500/50 hover:from-amber-500/[0.12] hover:to-red-500/[0.08] sm:max-w-md"
    >
      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-amber-500/15 text-amber-300">
        <Sparkles className="h-3 w-3" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-300">
          Boost-Empfehlung
        </span>
        <span className="mt-0.5 line-clamp-1 text-xs text-zinc-300">{reason}</span>
        <span className="mt-0.5 inline-flex items-center gap-1 text-[11px] text-zinc-500">
          <TrendingUp className="h-2.5 w-2.5 text-emerald-400" /> {hint}
        </span>
      </span>
      <span className="shrink-0 self-center text-[11px] font-semibold uppercase tracking-wider text-amber-300 group-hover:text-amber-200">
        Boosten →
      </span>
    </button>
  );
}
